import { ReportSummary } from '../../summary/services/ReportSummaryRepository';
import { useState } from 'react';
import { InventoryComparison } from '../models/InventoryComparison';
import { Typography, Table, TableRow, TableCell, TableHead, TableBody } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { InventoryComparisonTableRow } from './InventoryComparisonTableRow';

type Props = {
  currentReportSummary: ReportSummary;
  selectedReportSummary: ReportSummary;
};

export const InventoryComparisonTable = (props: Props) => {
  const { currentReportSummary, selectedReportSummary } = props;
  const [inventoryComparison] = useState(() => new InventoryComparison(currentReportSummary, selectedReportSummary));
  const { t } = useTranslation();

  return (
    <Table sx={{ tableLayout: 'fixed' }} role="presentation">
      <TableHead>
        <TableRow>
          <TableCell width="35%">
            <Typography variant="subtitle2" component="span">
              {t('comparison.inventory.typeCol')}
            </Typography>
          </TableCell>
          <TableCell>
            <Typography variant="subtitle2" component="span">
              {t('comparison.inventory.beforeCol')}
            </Typography>
          </TableCell>
          <TableCell>
            <Typography variant="subtitle2" component="span">
              {t('comparison.inventory.nowCol')}
            </Typography>
          </TableCell>
          <TableCell>
            <Typography variant="subtitle2" component="span">
              {t('comparison.inventory.changeCol')}
            </Typography>
          </TableCell>
          <TableCell aria-hidden width="5%" align="right"></TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {Object.keys(inventoryComparison.data)
          .sort()
          .map((categoryName) => {
            return <InventoryComparisonTableRow key={categoryName} categoryName={categoryName} inventoryComparison={inventoryComparison} />;
          })}
      </TableBody>
    </Table>
  );
};
